<template>
  <div class="c-form">
    <el-form label-width="50px" inline class="elementui-common-form-styles" v-highlight>
      <el-form-item>
        <ThrottleSelector v-model="mgameId" :list="gameData" style="width: 160px" placeholder="请选择中间件游戏" filterable clearable />
      </el-form-item>

      <el-form-item>
        <ThrottleSelector v-model="platform" :list="platformData" style="width: 160px" placeholder="请选择平台" filterable clearable />
      </el-form-item>

      <el-form-item class="bg-transparent">
        <div class="operate-btns">
          <slot name="upload"></slot>

          <el-button @click="$emit('on-down')">运营KPI模板下载</el-button>
          <el-button type="primary" @click="$emit('on-add')">新建KPI</el-button>
        </div>
      </el-form-item>
    </el-form>
  </div>
</template>
<script>
import ThrottleSelector from '@/components/throttle-select/index.vue'
import { platformData } from '../../data/platformData.js'
export default {
  name: 'KpiFilter',
  components: { ThrottleSelector },
  props: {
    gameData: {
      type: Array
    }
  },
  data() {
    return {
      mgameId: '',
      platform: '',
      platformData
    }
  },
  methods: {
    sendEvent() {
      this.$emit('on-change', {
        platform: this.platform === '' ? undefined : this.platform,
        mgameId: this.mgameId === '' ? undefined : this.mgameId
      })
    },

    emitImport(file) {
      this.$emit('on-import', file)
    }
  },
  watch: {
    platform() {
      this.sendEvent()
    },
    mgameId() {
      this.sendEvent()
    }
  }
}
</script>
<style lang="scss" scoped>
.operate-btns {
  display: flex;
}
</style>
